/* eslint-disable no-else-return */
/* eslint-disable no-use-before-define */
import _ from 'underscore';
import { useMemo } from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

export default function usePaymentSettings({
  piid,
  piOptions,
  paymentType,
  paymentMethod,
  isLoading,
}) {
  const settings = useMemo(() => _.defaults(
    {},
    // NOTE: if we can get any payment settings from the PI, we want them to take priority over potential values from other sources
    getOverrides(getPaymentSettings({ piid, piOptions, isLoading })), {
      piid,
      type: paymentType != null ? paymentType : Constants.PaymentTypeId.Prepay,
      method: paymentMethod != null ? paymentMethod : Constants.PaymentInstrumentType.Unset,
      isLoading,
    }
  ), [piid, piOptions, paymentMethod, paymentType, isLoading]);

  return settings;
}

function getPaymentSettings({ piid, piOptions, isLoading }) {
  if (piid == null || isLoading) {
    return {};
  } else {
    const piDetails = _.findWhere(piOptions, { Id: piid }) || {};
    return {
      type: getPaymentType(piDetails),
      method: piDetails.Type,
    };
  }
}

// NOTE: if a PI supports both prepay and postpay,
// we leave the payment type selection to the upper layers (here: undefined, a.k.a. anything goes)
function getPaymentType({ SupportsPrepay, SupportsPostpay }) {
  if (!SupportsPrepay) {
    return Constants.PaymentTypeId.Postpay;
  } else if (!SupportsPostpay) {
    return Constants.PaymentTypeId.Prepay;
  } else {
    return undefined;
  }
}

function getOverrides(object) {
  return _.mapObject(object, getOverrideValue);
}

function getOverrideValue(value) {
  return value == null ? undefined : { value, type: 'override' };
}
